export const setFirstLogin = () => {
  localStorage.setItem('firstLogin', 'true');
};
export const getFirstLogin = () => {
  const firstLogin = localStorage.getItem('firstLogin');
  if (firstLogin === 'true') localStorage.setItem('firstLogin', 'false');
  return firstLogin === 'true';
};
